import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const KEY = "ninyaa_cookie_consent";
const DEFAULT_TEXT = "Nous utilisons uniquement des cookies essentiels au fonctionnement et à la sécurité de la plateforme (authentification, session). Aucun traceur publicitaire n'est déposé.";

export default function CookieConsent() {
  const { cabinet } = useAuth() || {};
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch (e) { /* noop */ }
  }, []);
  const decide = (v) => { try { localStorage.setItem(KEY, v); } catch (e) { /* noop */ } setShow(false); };
  if (!show) return null;
  const text = (cabinet && cabinet.cookie_banner_text) || DEFAULT_TEXT;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-3 sm:p-4" data-testid="cookie-consent">
      <div className="max-w-3xl mx-auto rounded-xl border border-border bg-card shadow-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Cookie size={22} className="text-primary shrink-0" />
        <p className="text-xs text-muted-foreground leading-relaxed flex-1">
          {text}{" "}
          <Link to="/confidentialite" className="text-primary hover:underline" data-testid="cookie-privacy-link">Protection des données</Link>.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <Button size="sm" variant="ghost" onClick={() => decide("essential")} data-testid="cookie-refuse">Refuser le non-essentiel</Button>
          <Button size="sm" onClick={() => decide("all")} data-testid="cookie-accept">J'ai compris</Button>
        </div>
      </div>
    </div>
  );
}
